<template>
  <el-dialog
    :model-value="modelValue"
    :title="`选择${msgType === 7 ? '问答菜单' : '文本菜单'}`"
    width="800px"
    append-to-body
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
  >
    <MaterialListDisplay
      v-model:selected-ids="selectedIds"
      :channel-key="channelKey"
      :material-type="msgType === 7 ? 'qa_menu' : 'text_menu'"
      :account-id="0"
      selection-mode="single"
      @change="onItemChange"
    />
    <template #footer>
      <el-button @click="emit('update:modelValue', false)">取消</el-button>
      <el-button type="primary" :disabled="!selectedItem" @click="onConfirm">确认</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import MaterialListDisplay from '@/components/materialList/MaterialListDisplay.vue';
import type { ChannelMaterialItem } from '@/types/channelMaterials';
import type { MenuTemplate } from '@/types/chatBox';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    msgType: number;
    channelKey?: string;
  }>(),
  {
    channelKey: 'web',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void;
  (
    e: 'confirm',
    data: {
      id?: number;
      guide_words?: string;
      quest?: Record<string, unknown>;
      content?: string | Record<string, unknown>;
      title?: string;
    },
  ): void;
}>();

const selectedIds = ref<number[]>([]);
const selectedItem = ref<ChannelMaterialItem | null>(null);

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      selectedIds.value = [];
      selectedItem.value = null;
    }
  },
);

const onItemChange = (items: ChannelMaterialItem[]) => {
  selectedItem.value = items[0] ?? null;
};

function parseQuestions(questions?: string): unknown[] {
  if (!questions) return [];
  try {
    return (JSON.parse(questions) as { questions?: unknown[] })?.questions ?? [];
  } catch {
    return [];
  }
}

function parseMeta(questions?: string): { auto_num?: number; conclusion?: string } | null {
  if (!questions) return null;
  try {
    return JSON.parse(questions) as { auto_num?: number; conclusion?: string };
  } catch {
    return null;
  }
}

function onConfirm() {
  if (!selectedItem.value) return;
  const tpl = selectedItem.value as unknown as MenuTemplate;
  const meta = parseMeta(tpl.questions);
  const questions = parseQuestions(tpl.questions);
  emit('confirm', {
    id: selectedItem.value.id,
    title: tpl.title,
    guide_words: tpl.guide_words,
    quest: meta ? { ...meta, questions } : {},
    content: tpl.send_questions
      ? { guide_words: tpl.guide_words, quest: meta, content: tpl.send_questions }
      : tpl.guide_words || '',
  });
  emit('update:modelValue', false);
}
</script>
